var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    _vm._g(
      _vm._b(
        {
          staticClass: "c-custom_dialog",
          attrs: {
            visible: _vm.dialogVisible,
            width: _vm.width,
            modal: _vm.modal,
            "append-to-body": true,
            "show-close": false,
            "close-on-click-modal": _vm.closeOnClickModal,
            "close-on-press-escape": _vm.closeOnPressEscape,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.onClose,
          },
          scopedSlots: _vm._u(
            [
              {
                key: "title",
                fn: function () {
                  return [
                    _c(
                      "div",
                      { staticClass: "c-custom_dialog__module_title" },
                      [
                        _c(
                          "div",
                          { staticClass: "title_container" },
                          [
                            _vm.title
                              ? _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      placement: "top",
                                      content: _vm.title,
                                      disabled: _vm.isShowTooltip,
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "title",
                                        on: {
                                          mouseover: function ($event) {
                                            return _vm.onIsShowTooltipByMouseOver(
                                              `custom_dialog_title_${_vm.titleId}`
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            attrs: {
                                              id: `custom_dialog_title_${_vm.titleId}`,
                                            },
                                          },
                                          [_vm._v(_vm._s(_vm.title))]
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._t("title"),
                            _vm.isShowClose
                              ? _c("div", { staticClass: "close_wrap" }, [
                                  _c("i", {
                                    staticClass: "el-icon-close",
                                    on: { click: _vm.onClose },
                                  }),
                                ])
                              : _vm._e(),
                          ],
                          2
                        ),
                      ]
                    ),
                  ]
                },
                proxy: true,
              },
              {
                key: "default",
                fn: function () {
                  return [
                    _c(
                      "div",
                      { staticClass: "c-custom_dialog__module_content" },
                      [
                        _c(
                          "div",
                          [_vm._t("default", null, { params: _vm.params })],
                          2
                        ),
                      ]
                    ),
                  ]
                },
                proxy: true,
              },
              {
                key: "footer",
                fn: function () {
                  return [
                    _vm.defaultFooter
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "c-custom_dialog__module_default_footer",
                          },
                          [
                            _vm.isShowClose
                              ? _c("div", { on: { click: _vm.onClose } }, [
                                  _vm._v("取 消"),
                                ])
                              : _vm._e(),
                            _c("div", { on: { click: _vm.onConfirm } }, [
                              _vm._v(_vm._s(_vm.defaultFooterText)),
                            ]),
                          ]
                        )
                      : _c(
                          "div",
                          { staticClass: "c-custom_dialog__module_footer" },
                          [_vm._t("footer", null, { params: _vm.params })],
                          2
                        ),
                  ]
                },
                proxy: true,
              },
            ],
            null,
            true
          ),
        },
        "el-dialog",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }